import { FC } from "react";

/**
 * Eye Icon Props Interface
 * @interface EyeProps
 */
interface EyeProps {
  color?: string;
  size?: number;
}

const People: FC<EyeProps> = ({ size = 24, color }) => {
  return (
    <>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1053_85543)">
          <path
            d="M16.67 13.1309C18.04 14.0609 19 15.3209 19 17.0009V20.0009H23V17.0009C23 14.8209 19.43 13.5309 16.67 13.1309Z"
            fill="black"
          />
          <path
            d="M15 12C17.21 12 19 10.21 19 8C19 5.79 17.21 4 15 4C14.53 4 14.09 4.1 13.67 4.24C14.5 5.27 15 6.58 15 8C15 9.42 14.5 10.73 13.67 11.76C14.09 11.9 14.53 12 15 12Z"
            fill="black"
          />
          <path
            d="M9 12C11.21 12 13 10.21 13 8C13 5.79 11.21 4 9 4C6.79 4 5 5.79 5 8C5 10.21 6.79 12 9 12Z"
            fill="black"
          />
          <path
            d="M9 13C6.33 13 1 14.34 1 17V20H17V17C17 14.34 11.67 13 9 13Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_1053_85543">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export default People;
